import { render, staticRenderFns } from "./CategoryEditorScreen.vue?vue&type=template&id=e4c570b8&"
import script from "./CategoryEditorScreen.vue?vue&type=script&lang=js&"
export * from "./CategoryEditorScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports